export default __webpack_public_path__ + "static/media/homeImage.3f0a17df.png";